import { Component, ViewEncapsulation } from '@angular/core';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { GlobalsService } from '../../shared/services/globals.service';
import { v_DispatchBus } from '../../shared/models/v_DispatchBus';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { MSFilterClass } from '@app/cp/shared/classes/filters/MSFilterClass';

@Component({
    selector: 'dispatch-third-party-history-dialog',
    templateUrl: './dispatch-third-party-history-dialog.component.html',
    styleUrls: ['./dispatch-third-party-history-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DispatchThirdPartyHistoryDialogComponent extends BaseGridUIComponent<v_DispatchBus, null, DispatchesService>  {

    dispatchStatusFC: MSFilterClass = new MSFilterClass('dispatchStatusName');
    dispatchPriorityFC: MSFilterClass = new MSFilterClass('priorityName');
    showHistory: boolean = false;
    constructor(svc_data: DispatchesService, globals: GlobalsService) {
        super(globals);
        this.svc_data = svc_data;

    }
    closeHistory() {
        this.showHistory = false;

    }
    openHistory(id: any) {
        this.id = id;
        this.showHistory = true;
        this.getDataById(id);

    }

    getDataById(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.subs_data = this.svc_data.getDispatchThirdPartyHistory(id).subscribe((info: any) => {
                    this.gridData = info ;
                    this.getData();
            });
        }
    }
}
